export * from './apiConfig'



// WEBPACK FOOTER //
// ./src/config/api/index.ts